module.exports = __webpack_public_path__ + "static/media/dry-van-left-facing.3720861f.svg";